<template>
  <ValidationObserver v-slot="{ handleSubmit }" v-loading="isBusy">
    <form @submit.prevent="handleSubmit(addPersonInCharge)">
      <div>
        <div style="display: flex; flex-direction: column;">
          <span style="font-weight: bold">Bạn đã chọn {{ taskList.length }} tác vụ.</span>
          <span>Vui lòng chọn admin để phân công chấm thi:</span>
        </div>
        <ValidationProvider vid="personInCharge" name="Người phụ trách" rules="required" v-slot="{ errors,classes }">
          <div class="display-flex-column">
            <span>Người phụ trách <span style="color: red">*</span></span>
            <el-select v-model="personInCharge" filterable clearable placeholder="Chọn nhân sự phụ trách">
              <el-option
                  v-for="item in adminList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
        <ValidationProvider vid="deadline" name="Thời hạn chấm bài" rules="required" v-slot="{ errors }">
          <div class="display-flex-column">
            <span>Thời hạn chấm bài <span style="color: red">*</span></span>
            <el-date-picker
                v-model="deadline"
                type="datetime"
                format="dd-MM-yyyy HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="Chọn thời hạn chấm bài"
                :picker-options="pickerOptions"
                style="width: 100%"
                clearable>
            </el-date-picker>
          </div>
          <div class="fv-plugins-message-container">
            <div data-field="deadline" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
          </div>
        </ValidationProvider>
      </div>
      <div style="display: flex;justify-content: flex-end; gap: 5px; margin-top: 20px">
        <el-button style="background: lightgray;" @click="closeDialog">Hủy bỏ</el-button>
        <button
            v-loading="loading"
            type="submit"
            style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px"
            :disabled="loading">
          Xác nhận
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  ASSIGN_ADMIN_TASK,
  GET_ALL_ADMIN_TEST,
} from "@/core/services/store/examSchedule/examSchedule";

export default {
  name: 'DialogTaskAssignment',
  props: {
    taskList: {
      type: Array,
      default: [],
      required: true,
    },
  },
  data() {
    return {
      personInCharge: null,
      deadline: null,
      adminList: [],
      loading: false,
      isBusy: true,
    }
  },
  computed: {
    pickerOptions() {
      const now = new Date()
      const isToday = this.deadline &&
          new Date(this.deadline).toDateString() === now.toDateString()
      const hours = now.getHours().toString().padStart(2, '0')
      const minutes = now.getMinutes().toString().padStart(2, '0')
      const seconds = now.getSeconds().toString().padStart(2, '0')
      return {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
        selectableRange: isToday
            ? `${hours}:${minutes}:${seconds} - 23:59:59`
            : '00:00:00 - 23:59:59'
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    getAdminList() {
      this.$store.dispatch(GET_ALL_ADMIN_TEST).then(res => {
        if (!res.error) {
          this.adminList = res.data.map((item) => {
            return {
              id: item.id,
              name: item.user_name,
            }
          })
          this.isBusy = false
        }
      })
    },
    addPersonInCharge() {
      this.loading = true
      const payload = {
        task_ids: this.taskList.map((item) => {
          return item.id
        }),
        admin_profile_id: this.personInCharge,
        deadline: this.deadline
      }
      this.$store.dispatch(ASSIGN_ADMIN_TASK, payload).then(res => {
        if (!res.error) {
          this.$message.success('Phân công tác vụ thành công')
          this.closeDialog()
          this.$emit('getManageTaskList')
        }
      }).catch(e => {
        this.$message.error( e.data.message || 'Phân công tác vụ thất bại')
      }).finally(() => this.loading = false)
    }
  },
  mounted() {
    this.getAdminList()
  }
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 20px;
}
</style>